import { 
    ballDiametr, 
    dotDiametr, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot, 
    line,
    LINE_ANIMATION_TIME
 } from '../../initials';
export class FinaleLineAnimationTopRight {
    constructor({
        fromRowIndex,
        fromDotIndex,
        isLeftMove,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.isLeftMove = isLeftMove;
        this.dots = dots;

    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'FinaleLineAnimationTopRight',
            fromBallPositionByDot: BallPositionByDot.TOP_RIGHT,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return LINE_ANIMATION_TIME;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const middleDot = this.isLeftMove ? this.dots[this.fromRowIndex - 1][this.fromDotIndex - 1] : this.dots[this.fromRowIndex - 1][this.fromDotIndex];
        const endPosition = {
            x: middleDot.dotX,
            y: this.dots[this.dots.length - 1][0].dotY + ballDiametr * 2.5,
        };

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, Math.PI / 4);

        return {
            x: line(
                startXY.x,
                endPosition.x, 
                t,
            ),
            y: line(
                startXY.y,
                endPosition.y - dotDiametr * 2, 
                t,
            ),
        };
    }
}